<template>
  <div>
    <!-- <div class="section-description"></div> -->
    <div class="section-paragraph" v-if="!isPreview">
      <add-element-button
        :addElBtnCustomRef="`add-btn-modal-${index}-section-paragraph`"
        :getThemeSettings="getThemeSettings"
        :callback="updateContent"
        :html="content.html"
      ></add-element-button>
    </div>
    <div class="section-paragraph" v-else v-html="content.html"></div>
  </div>
</template>
<script>
import AddElementButton from '../button/add-element';
import quillMixin from '../../../mixins/quill';

export default {
  name: 'JustText',
  mixins: [quillMixin],
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    index: {},
    getThemeSettings: {},
    content: {
      type: Object,
      required: true,
    },
  },
  components: {
    AddElementButton,
  },
  methods: {
    updateContent(contentString) {
      this.$emit('updateSectionContent', { html: contentString });
    },
  },
};
</script>